import CalendarSurfaceStore from '../store/schema/CalendarSurfaceStore';
import getSurfaceStore from '../store/store';
import { areDateRangesEqual, DateRange } from 'mini-datetime-utils';
import { mutatorAction } from 'satcheljs';

const updateDateRange = mutatorAction('updateDateRange', (newDateRange: DateRange) => {
    const store: CalendarSurfaceStore = getSurfaceStore();
    if (!areDateRangesEqual(newDateRange, store.dateRange)) {
        store.dateRange = newDateRange;
    }
});

export default updateDateRange;
